var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFormCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "form-complete 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_00000009571707996108943840000002508793138964693929_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M115.499 51.1992H45.3994V56.0992H115.499V51.1992Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M115.499 79.5H45.3994V84.4H115.499V79.5Z",
    fill: "#D51E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M78.9994 107.699H45.3994V112.599H78.9994V107.699Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.0998 131.699V32.7992C21.0998 26.5992 26.0998 21.5992 32.2998 21.5992H130.8C137 21.5992 142 26.5992 142 32.7992V99.3992H146.9V32.7992C146.9 23.8992 139.7 16.6992 130.8 16.6992H32.3998C23.4998 16.6992 16.2998 23.8992 16.2998 32.7992V131.699C16.2998 140.599 23.4998 147.799 32.3998 147.799H99.2998V142.899H32.3998C26.1998 142.899 21.0998 137.899 21.0998 131.699Z",
    fill: "#3363AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M151.3 119.699L129.1 141.899L117.3 129.999L113.8 133.499L129.1 148.799L154.8 123.199L151.3 119.699Z",
    fill: "#D51E1E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFormCompleted);
export default __webpack_public_path__ + "static/media/icon_form_completed.ab4f2182fe6c5df1f891ce8b9b11772e.svg";
export { ForwardRef as ReactComponent };